import axios from "axios";
import { AppThunk } from "../../../config/store";
import { SignUpAction } from "./slices";
import {
  IndividualRegistrationRequest,
  OrganisationRegistrationRequest,
} from "@advapacs/clinician-api-protos/dist/Registration";
import { registerApi } from "../../../config/api";
import parsePhoneNumber from "libphonenumber-js";
import {
  exposeCaptchaHeaders,
  graceFullyPhoneFormat,
  IErrorMessage,
  IMobileNumber,
} from "@advapacs/common";

export const signUpIndividual =
  (
    model: IndividualRegistrationRequest,
    mobilePhoneModel: IMobileNumber,
    recaptchaValue: string,
    lang: string,
    token?: string,
    turnstile?: boolean
  ): AppThunk =>
  async (dispatch) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const requestModel: any = IndividualRegistrationRequest.toJSON(model);
      let parseNumber;
      if (mobilePhoneModel?.mobilePhone && mobilePhoneModel?.countryCode) {
        // we should check all field in model instead just one
        const number = `+${mobilePhoneModel?.countryCode?.value}${mobilePhoneModel?.mobilePhone}`;
        parseNumber = parsePhoneNumber(graceFullyPhoneFormat(number));
      }

      dispatch(SignUpAction.signUpIndividualStart());
      const request = {
        ...requestModel,
        language: lang,
        contactNumber: mobilePhoneModel?.mobilePhone
          ? parseNumber?.number
          : undefined,
        token,
      };
      const response = await axios.post(registerApi.INDIVIDUAL, request, {
        // @ts-ignore
        headers: exposeCaptchaHeaders(turnstile, recaptchaValue),
      });
      dispatch(SignUpAction.signUpIndividualSuccess(response.data));
    } catch (err) {
      dispatch(
        SignUpAction.signUpIndividualFail(
          (err as IErrorMessage)?.response?.data
        )
      );
    }
  };

export const signUpOrganisation =
  (
    model: OrganisationRegistrationRequest,
    recaptchaValue: string,
    lang: string,
    turnstile?: boolean
  ): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(SignUpAction.signUpOrganisationStart());
      const response = await axios.post(
        registerApi.ORGANISATION,
        {
          ...model,
          organisationId: model.organisationId?.toLowerCase(),
          language: lang,
        },
        {
          // @ts-ignore
          headers: exposeCaptchaHeaders(turnstile, recaptchaValue),
        }
      );
      dispatch(SignUpAction.signUpOrganisationSuccess(response.data));
    } catch (err) {
      dispatch(
        SignUpAction.signUpOrganisationFail(
          (err as IErrorMessage)?.response?.data
        )
      );
    }
  };

export const resendEmail =
  (registrationId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(SignUpAction.resendEmailStart());
      await axios.post(registerApi.RESEND_EMAIL, { id: registrationId });
      dispatch(SignUpAction.resendEmailSuccess());
    } catch (err) {
      dispatch(
        SignUpAction.resendEmailFail((err as IErrorMessage)?.response?.data)
      );
    }
  };

export const complete =
  (id: string, token: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(SignUpAction.completeStart());
      const response = await axios.post(registerApi.COMPLETED, { id, token });
      dispatch(SignUpAction.completeSuccess(response.data));
    } catch (err) {
      dispatch(
        SignUpAction.completeFail((err as IErrorMessage)?.response?.data)
      );
    }
  };
